import { useGlobal } from '@/utils/useGlobal';
import styles from './index.module.scss';
import EFPicture from '@elem/ui/ef-picture';

const Uninterrupted = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('OceanProHomeSolarBattery');

    return (
        <div className={`${styles.uninterrupted} GtmModuleData-section`} data-section-id={styles.uninterrupted} data-section-title={t(`uninterrupted_title`)}>
            <div className="content">
                <div className="text-container">
                    <h5 className="label">{t(`uninterrupted_label`)}</h5>
                    <h2>{t(`uninterrupted_title`)}</h2>
                    <p className="intro">
                        {t.rich(`uninterrupted_intro`, {
                            sup: (text: string) => <sup>{text}</sup>,
                        })}
                    </p>
                </div>
                <EFPicture
                    src="https://websiteoss.ecoflow.com/upload/image/1760175660313/Uninterrupted-pc.png"
                    srcMobile="https://websiteoss.ecoflow.com/upload/image/1759998617916/Uninterrupted-h5.jpg"
                    alt={t(`uninterrupted_title`)}
                    className="banner"
                />
            </div>
        </div>
    );
};

export default Uninterrupted;
